/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Icon, GridSet, GridItem, Link } from '@insticator/insticator-ui'; // iui-material
import AddableEmail from 'material/addableemaillist/addableemail/addableemail';
// utils
import { validation } from 'utils/validation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/addableemaillist/addableemaillist_styles';



/* ========== ~~~~~~~~~~ ADDABLE EMAIL LIST ~~~~~~~~~~ ========== */
class AddableEmailList extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.usersPermitted && this.props.allUsers.length < 1) this.props.getUsers(this.props.accountUUID);
    }

    checkIfValid = (email) => (
        validation.email.test.test(email)
    )

    editEmail = (item, index) => (
        this.props.editEmail({value: item, index, valid: this.checkIfValid(item)})
    )

    getAddableEmail = (email, valid, index) => (
        <div className={`addable-email-div`}>
            <AddableEmail value={email} valid={valid} required={true} allUsers={this.props.allUsers} handleSelect={(email) => {this.editEmail(email, index)}} handleBlur={(email) => {this.editEmail(email, index)}}/>
            { this.props.emails.length > 1 && <Link type={`custom`} text={``} handleClick={(e) => this.removeEmail(index)} icon={`times-circle`} iconRight /> }
        </div>
    );

    addEmail = (value) => {
        value = value.length > 0 ? value : "";
        this.props.addEmail(value);
    };

    removeEmail = (index) => (
        this.props.removeEmail(index)
    );

    getAddNewAddableEmailLink = () => (
        <Link type={`custom`} text={`Add a new address`} color={`primary`} handleClick={this.addEmail} icon={`plus-circle`} iconRight />
    );

    getEmailList = () => (
        <GridSet direction={`vertical`}>
            {this.props.emails.map((email, index) => (
                    <GridItem key={`${index}`}>
                        {this.getAddableEmail(email.value, email.valid, index)}
                    </GridItem>
                ))
            }
        </GridSet>
    );

    render() {
        return (
            <div className={`addableemaillist ${this.props.classes.addableemaillist}`}>
                {this.props.emails.length > 0 ? this.getEmailList() : this.addEmail(this.props.userEmail)}
                {this.getAddNewAddableEmailLink()}
            </div>
        );
    }

};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddableEmailList);
